import React from 'react';

const PricingHero = () => {
  return (
    <header className="col-xs-12 Hero">
      <div className="row bottom-xs">
        <div className="col-xs-12 col-sm-10 col-md-10 col-lg-8 col-lg-offset-2">
          <h1 className="Hero-text">New pricing<br />coming soon.</h1>
          <p>Thousands of teams and individuals rely on
              Clara to support their businesses and save them time.
          </p>
        </div>
        <p className="u-hidden-xs u-hidden-sm u-block-md col-sm-2 Hero-aside">
          <a className="Hero-asideLink" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdGpdFyvfpL43qhJGQ3HQs5yQwOHRW04qEeCbf05YHBHQy4tQ/viewform">Join Beta</a>
          <br />
        </p>
      </div>
    </header>
  );
};
PricingHero.propTypes = {
  conversionFlow: Boolean,
};

export default PricingHero;
